import { useState } from "react";
import type { ReactNode } from "react";
import { EyeRegular, EyeOffRegular, CopyRegular, CheckmarkRegular } from "@fluentui/react-icons";
import styles from "./PasswordDisplay.module.scss";

interface IPasswordDisplayProps {
  password: string;
}

export function PasswordDisplay({ password }: IPasswordDisplayProps): ReactNode {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const maskedPassword = "*".repeat(password.length > 0 ? 13 : 0);

  const handleCopy = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(password);
      setIsCopied(true);
      setTimeout((): void => setIsCopied(false), 2000);
    } catch {
      // Fallback: silently fail if clipboard API is unavailable
    }
  };

  return (
    <span className={styles.container}>
      <span className={styles.password} aria-label="Workbook password">
        {isVisible ? password : maskedPassword}
      </span>
      <button
        type="button"
        className={styles.toggleButton}
        onClick={(): void => setIsVisible((prev) => !prev)}
        aria-label={isVisible ? "Hide password" : "Show password"}
      >
        {isVisible ? <EyeOffRegular /> : <EyeRegular />}
      </button>
      {isVisible && (
        <button
          type="button"
          className={`${styles.toggleButton} ${isCopied ? styles.copied : ""}`}
          onClick={handleCopy}
          aria-label={isCopied ? "Password copied" : "Copy password to clipboard"}
        >
          {isCopied ? <CheckmarkRegular /> : <CopyRegular />}
        </button>
      )}
    </span>
  );
}
